import { useEffect } from 'react'
import { SocketChat } from '../SocketChat'
import { useDispatch } from 'react-redux'
import { ScoopColumn } from '../../../ui'
import { ModalProvider, ModalOutlet } from '../../../modals'
import styles from './PublicSocketChat.module.scss'

// Demo configurations for different environments
const DEMO_CONFIGS = {
    opportunities: {
        workspace: process.env.REACT_APP_OPPORTUNITIES_DEMO_WORKSPACE,
        token: process.env.REACT_APP_OPPORTUNITIES_DEMO_TOKEN,
        user: process.env.REACT_APP_OPPORTUNITIES_DEMO_USER,
        inbox: process.env.REACT_APP_OPPORTUNITIES_DEMO_INBOX,
        welcomeMessage:
            'Welcome to Open Opportunities Demo Chat! Ask me about available opportunities.',
        contextPrompt: 'You are helping users explore open opportunities data.',
    },
    housing: {
        workspace: process.env.REACT_APP_HOUSING_DEMO_WORKSPACE,
        token: process.env.REACT_APP_HOUSING_DEMO_TOKEN,
        user: process.env.REACT_APP_HOUSING_DEMO_USER,
        inbox: process.env.REACT_APP_HOUSING_DEMO_INBOX,
        welcomeMessage: 'Welcome to Housing Demo Chat! Ask me about housing data and trends.',
        contextPrompt: 'You are helping users analyze housing data and market trends.',
    },
}

// Wrapper component for public chat without authentication
export const PublicSocketChat = ({ demoType }) => {
    const dispatch = useDispatch()

    // Get configuration based on demo type - only opportunities or housing
    const config = DEMO_CONFIGS[demoType]

    useEffect(() => {
        setTimeout(() => {
            dispatch({
                type: 'SWITCH_WORKSPACE',
                workspaceID: config.workspace,
            })
            dispatch({
                type: 'SET_AUTHENTICATED',
                isAuthenticated: true,
                isDemoUser: true, // Flag to identify demo users
                user: {
                    signInUserSession: {
                        idToken: { jwtToken: config.token },
                        refreshToken: { token: config.token },
                    },
                    username: config.user,
                    attributes: {
                        email: null,
                    },
                },
            })
        })
    }, [dispatch, config])

    return (
        <ModalProvider>
            <ScoopColumn className={styles.container}>
                {/* Render chat without nav bar wrapper */}
                <ScoopColumn className={styles.chatWrapper}>
                    {/* Pass demo configuration to SocketChat */}
                    <SocketChat
                        isPublic
                        publicConfig={config}
                        selectedInbox={{ inboxID: config.inbox }}
                    />
                </ScoopColumn>
            </ScoopColumn>
            <ModalOutlet />
        </ModalProvider>
    )
}
